import { render } from "./OrderDataForUpload.vue?vue&type=template&id=68dcc06b"
import script from "./OrderDataForUpload.vue?vue&type=script&lang=js"
export * from "./OrderDataForUpload.vue?vue&type=script&lang=js"

import exportComponent from "C:\\Users\\caleb\\OneDrive\\Desktop\\apps\\kff_ordering_portal\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__